import { render, staticRenderFns } from "./EditProductForm.vue?vue&type=template&id=44ecfa48&scoped=true&"
import script from "./EditProductForm.vue?vue&type=script&lang=js&"
export * from "./EditProductForm.vue?vue&type=script&lang=js&"
import style0 from "./EditProductForm.vue?vue&type=style&index=0&id=44ecfa48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ecfa48",
  null
  
)

export default component.exports